import { getGlobalGtmParams } from './gtm/globalParams';

/* eslint-disable @typescript-eslint/no-explicit-any */
type TRegistrationGatekeeper = {
  messageBus: {
    subscribe: (topic: string, callback: (data: any) => void) => void;
    publish: (topic: string, data: any) => void;
  };
  auth: {
    logIn: () => Promise<void> | void;
    logOut: () => Promise<void> | void;
    isLoggedIn: () => Promise<boolean> | boolean;
    getAccessToken: () => Promise<string | undefined> | string;
    getCasumoName: () => Promise<string | undefined> | string;
    getName: () => Promise<string | undefined> | string;
    getSessionId: () => Promise<string | undefined> | string;
    getPlayerId: () => Promise<string | undefined> | string;
  };
  localisation: {
    marketSlug: string;
    localeCode: string;
    systemMarketSlug: string;
  };
  navigation: {
    getRoute: (routeId: string, params?: any, options?: any) => string | null;
    navigate: (routeId: string, options?: any) => Promise<void> | string;
    getCurrentRoute: () => {
      template: string;
      page: string;
      params: string;
    };
    isActiveRoute: (routeId: string, params: any) => boolean;
  };
  wallet: {
    getPlayerCurrency: () => void;
  };
  staticContext: {
    gatewayBaseUrl: string;
  };
  featureToggles?: {
    bypassCache?: boolean;
    contentMode?: 'draft' | 'published';
  };
  fetch: typeof fetch;
  deviceInfo: {
    deviceId: string;
    deviceHasRegisteredPlayer?: boolean;
  };
  isNative: {
    (): boolean;
    (withProps: true): { ios?: boolean; android?: boolean } | false;
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any */

const mockedGateKeeper = {
  messageBus: {
    subscribe: () => {
    },
    publish: () => {
    },
  },
  auth: {
    logIn: () => {
    },
    logOut: () => {
    },
    isLoggedIn:     () => false,
    getAccessToken: () => '',
    getCasumoName:  () => 'Heisenberg',
    getName:        () => 'Walter White',
    getSessionId:   () => '',
    getPlayerId:    () => '',
  },
  localisation: {
    marketSlug: 'en',
    localeCode: 'en',
  },
  navigation: {
    navigate: () => '',
  },
  wallet: {
    getPlayerCurrency: () => {
    },
  },
  staticContext: {
    gatewayBaseUrl: '',
  },
  featureToggles: {
    bypassCache: false,
    contentMode: 'published' as const,
  },
  fetch:      (...args: Parameters<typeof fetch>) => fetch(...args),
  deviceInfo: { deviceId: '' },
  isNative:   (withProps?: boolean) =>
    (withProps ? window?.native || false : Boolean(window?.native)),
};

export const gatekeeper = (window?.fabric?.getGatekeeper(
  'v2.2.16',
  'fabric-registration',
) ?? mockedGateKeeper) as unknown as TRegistrationGatekeeper;

export const sendGtmEvent = ({
  topic = 'analytics',
  kind = 'gtm',
  feature = 'register',
  action = 'fail',
  data = {},
}: {
  topic?: 'analytics';
  kind?: 'gtm';
  feature?: string;
  action: string;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}) => {
  gatekeeper?.messageBus?.publish(topic, {
    kind,
    names: { feature, action },
    data:  { ...getGlobalGtmParams(), ...data },
  });
};
